import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faDotCircle,
  faMousePointer,
  faProjectDiagram,
  faTrash,
  faPaintBrush,
  faArrowRight
} from '@fortawesome/free-solid-svg-icons';

// Add icons to the library
library.add(
  faDotCircle,
  faMousePointer,
  faProjectDiagram,
  faTrash,
  faPaintBrush,
  faArrowRight
);
